import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import uri from "../../../constants/uri";

const saveQuestionFile = async (file, questionId) => {
	const formData = new FormData();
	formData.append("file", file);
	await client.post(`${uri}/question_attachment/${questionId}`, formData, {
		headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
	});
};

export default saveQuestionFile;
